var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCanolaCounts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59.84 59.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#50bade;stroke-width:3px;}.cls-1,.cls-2,.cls-3{stroke:#fff;stroke-miterlimit:10;}.cls-2,.cls-3{fill:none;stroke-width:1.5px;}.cls-2{stroke-linecap:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "canola-counts-blue"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 29.92,
    cy: 29.92,
    r: 28.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19,14.73l7.7-.72c2-4,4.79-3.69,6.63-.06l7.45.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M16.88,20.31a2.3,2.3,0,0,1,2.19-2.18l21.68,0a1.63,1.63,0,0,1,1.82,1.48L43,43.94a2.09,2.09,0,0,1-1.32,1.87l-23.46-.13a1.83,1.83,0,0,1-1.47-1.79Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 24.76,
    y1: 22.78,
    x2: 24.76,
    y2: 30.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 27.96,
    y1: 22.78,
    x2: 27.96,
    y2: 30.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 31.19,
    y1: 22.78,
    x2: 31.19,
    y2: 30.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 34.71,
    y1: 22.78,
    x2: 34.71,
    y2: 30.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 24.75,
    y1: 33.4,
    x2: 24.75,
    y2: 41.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 28.1,
    y1: 33.4,
    x2: 28.1,
    y2: 41.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 38.16,
    y1: 24.68,
    x2: 21.57,
    y2: 28.96
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCanolaCounts);
export default __webpack_public_path__ + "static/media/icon-canola-counts.cf0a57d0.svg";
export { ForwardRef as ReactComponent };